export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://localhost:8080',
  user: null,
  logins: [],
  token: null,
  userInfo: {
    messages: [{1: 'test', 2: 'test'}],
    notifications: [],
    tasks: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js